import { createAction, props } from '@ngrx/store';
import { PatientProvider } from '../../models/patient-provider';

export const getPatientCareTeam = createAction('[Care Team] Get Patient Care Team');

export const getPatientCareTeamSuccess = createAction(
  '[Care Team] Get Patient Care Team Success',
  props<{ careTeam: PatientProvider[] | null }>()
);

export const getPatientCareTeamFailure = createAction(
  '[Care Team] Get Patient Care Team Failure',
  props<{ error: unknown }>()
);
